import { Popup, PopupProps } from "lib/classes/popup";
import { getLocaleString } from "lib/localization/vendor";

// Interfaces
import MapToolMode from "lib/enums/maptoolmode";

const ToolSelect = new Popup({
	title: () => getLocaleString("toolselect"),
	style: {maxWidth: 550},
	distinct: true,
	render: function() {
		const drawOptions:Function = this.get("draw-options");
		const options:any[] = drawOptions();
		
		return (
			<>
				{options.length > 0 ? options : "No tools enabled"}
			</>
		)
	}
});

export default ToolSelect;